//# sourceMappingURL=project.mjs.map
/// <reference types="./project.d.mts" />
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $project from "../../admin/effects/project.mjs";
import * as $proposal_effects from "../../admin/effects/proposal.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Store } from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function update(store, msg) {
  if (msg instanceof $msg.ApiReturnedProjects) {
    let projects = msg.projects;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      new $remote.Loaded(projects),
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(
      _pipe,
      $effect.batch(
        (() => {
          let _pipe$1 = projects.elements;
          return $list.map(
            _pipe$1,
            (p) => { return $project.fetch_project_file(p.id); },
          );
        })(),
      ),
    );
  } else if (msg instanceof $msg.ApiReturnedProjectsFile) {
    let project_files = msg.project_files;
    let project_id = msg.project_id;
    return [
      new Store(
        store.connections,
        store.organizations,
        store.organizations_tags,
        store.organizations_users,
        store.organizations_invitations,
        store.organizations_enabled_connections,
        store.organizations_ai_config,
        store.organizations_qm_rows,
        store.connected_sockets,
        store.projects,
        store.proposals,
        store.page_index,
        store.proposal_elements,
        store.answers,
        store.translations,
        store.label_translations,
        store.label_translations_search,
        store.label_translations_language_filter,
        store.label_translations_sort,
        store.llm_rate_limits,
        store.organizations_activity,
        store.llm_usage,
        store.llm_usage_by_org,
        store.client,
        store.organization,
        store.route,
        store.user,
        store.user_id,
        store.content_library,
        store.ingestion_control_sources,
        store.ingestion_control_sources_visibility,
        store.loading,
        store.users,
        store.roles,
        store.maintenance_mode,
        store.data_sources,
        store.analytics,
        store.metrics_groups,
        store.dashboard_options,
        $dict.insert(store.project_files, project_id, project_files),
        store.weaviate_migrations,
        store.weaviate_collections,
        store.sitemap_urls,
      ),
      $effect.none(),
    ];
  } else {
    let page_index = msg.page_index;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(
      _pipe,
      $effect.batch(
        toList([
          $project.fetch_projects(page_index),
          $proposal_effects.fetch_proposals(page_index),
        ]),
      ),
    );
  }
}
